import { Fragment, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router';
import { useMenuCurrentItem } from '@/components/menu';
import { ContextBar, Footer, Header, Sidebar, useDemo1Layout } from '../';
import { useMenus } from '@/providers';
import { useIntl } from 'react-intl';
import AppChatmeSDK from '../chatbot/AppChatmeScript';
const Main = () => {
  const {
    layout
  } = useDemo1Layout();
  const {
    pathname
  } = useLocation();
  const {
    getMenuConfig
  } = useMenus();
  const menuConfig = getMenuConfig('primary');
  const menuItem = useMenuCurrentItem(pathname, menuConfig);
  const intl = useIntl();
  useEffect(() => {
    const bodyClass = document.body.classList;

    // Add a class to the body element
    bodyClass.add('demo1');
    if (layout.options.sidebar.fixed) bodyClass.add('sidebar-fixed');
    if (layout.options.sidebar.collapse) bodyClass.add('sidebar-collapse');
    if (layout.options.header.fixed) bodyClass.add('header-fixed');

    // Remove the class when the component is unmounted
    return () => {
      bodyClass.remove('demo1');
      bodyClass.remove('sidebar-fixed');
      bodyClass.remove('sidebar-collapse');
      bodyClass.remove('header-fixed');
    };
  }, [layout]);
  useEffect(() => {
    const timer = setTimeout(() => {
      document.body.classList.add('layout-initialized');
    }, 1000); // 1000 milliseconds

    // Remove the class when the component is unmounted
    return () => {
      document.body.classList.remove('layout-initialized');
      clearTimeout(timer);
    };
  }, []);
  return <Fragment>
      <Helmet>
        <title>
          {menuItem?.title ? 
            intl.formatMessage({ id: menuItem.title }) : 
            'Chatme'
          }
        </title>
      </Helmet>

      <Sidebar />

      <div className="wrapper flex flex-col w-full">
        <Header />
        {/* <ContextBar/> */}
        <AppChatmeSDK/>
        <main className="content bg-white w-full" role="content">
          <Outlet />
        </main>

        <Footer />
      </div>
    </Fragment>;
};
export { Main };